export const isScenarioCoachMessage = (message) => (
  message?.role === 'assistant'
  && message?.parts?.some(
    (part) => part?.type === 'text'
      && part?.content?.speaker_role === 'scenario_coach',
  )
);

export const newAssistantText = (previousMessages = [], nextMessages = []) => (
  nextMessages
    .slice(previousMessages.length)
    .filter((message) => message?.role === 'assistant' && !isScenarioCoachMessage(message))
    .map((message) => String(message?.content || '').trim())
    .filter(Boolean)
    .join('\n\n')
);

export const actionHasSpokenReply = (type) => (
  ['submit_text', 'select_choice', 'skip_question'].includes(type)
);

export const scenarioCoachText = (messages = []) => (
  messages
    .filter(isScenarioCoachMessage)
    .map((message) => String(message?.content || '').trim())
    .filter(Boolean)
    .join('\n\n')
);
